// cSpell: ignore avator, putao

import React from 'react';
import styled from 'styled-components';

import '../../static/css/layout-menu.css';

const UserCell = (props) => {
    const { photo, eng_name, course_position, abilityMedalId, integrals, starNum } = props.data;
    console.log(props.data);
    return (
        <InfoBox>
            <PicBox onClick={() => { window.location = `#/setting`; }} >
                <PicBorder image={abilityMedalId ? `https://webres.putaoabc.com/course/images/medal/avatar_${abilityMedalId}.png` : ''} />
                <Pic src={photo} />
                <Name>{eng_name}</Name>
            </PicBox>
            <StarBox>
                <Star />
                <Num >{starNum}</Num>
            </StarBox>
            <PCoin >
                <Coin />
                <Num >{integrals}</Num>
            </PCoin>
            <Gift onClick={() => { window.location = `#/my-gift?cid=${course_position.level}_${course_position.unit}_${course_position.lesson}`; }} />
        </InfoBox>
    );
}

export default UserCell;

const InfoBox = styled.div`
	position: fixed;
    left: 0.50rem;
    top: 0.54rem;
    transition: all 0.5s;
    width: 4.6rem;
    height: 0.6rem;
    border-radius: 0.3rem;
    background: rgba(123, 44, 255, 0.3);
    display: flex;
    flex-direction: row;
    font-size: 0.22rem;
    z-index: 10;
`;

const PicBox = styled.div`
	position: relative;
    width: 1.48rem;
    height: 1.12rem;
    margin-left: -0.20rem;
    margin-top: -0.28rem;
    cursor: pointer;
`;

const PicBorder = styled.div`
	position: absolute;
	width: 1.48rem;
    height: 1.12rem;
    z-index: 9;
    background: url(${require('../../static/img/layout-menu/avator-border.png')}) no-repeat center;
    background-size: contain;

    /* ${props => props.image ? `
        background: url(${props.image}) no-repeat center;
        background-size: contain;
    ` : ''} */
`;

const Pic = styled.div`
    position: absolute;
    left: 0.32rem;
    top: 0.08rem;
    width: 0.86rem;
    height: 0.86rem;
	border-radius: 50%;
	background: url(${props => props.src ? props.src : require('../../static/img/layout-menu/avator.png')}) no-repeat center;
	background-size: cover;
`;

const Name = styled.div`
	position: absolute;
    bottom: 0.12rem;
    width: 100%;
    text-align: center;
    color: #fff596;
    font-size: 0.24rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    z-index: 99;
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
`;

const NumBox = styled.div`
	position: relative;
    height: 0.45rem;
    margin-top: 0.07rem;
    margin-left: 0.1rem;
    border-radius: 0.3rem;
	background: rgba(123, 44, 255, 0.8);
	line-height: 0.45rem;
`;

const StarBox = styled(NumBox)`
    width: 1rem;
`;

const Star = styled.div`
	position: absolute;
    left: 0.14rem;
    top: 0.05rem;
    width: 0.35rem;
    height: 0.35rem;
    background: url(${require('../../static/img/layout-menu/star.png')}) no-repeat center;
    background-size: contain;
`;

const Num = styled.div`
	width: 0.4rem;
    height: 0.28rem;
    text-align: center;
    position: absolute;
    left: 0.5rem;
    color: #e5d8fc;
`;

const PCoin = styled(NumBox)`
    width: 1.2rem;
`;

const Coin = styled.div`
    position: absolute;
    width: 0.35rem;
    height: 0.35rem;
    left: 0.14rem;
    top: 0.05rem;
    background: url('https://webres.putaoabc.com/course/images/medal/score_icon.png') no-repeat center;
    background-size: contain;
`;

const Gift = styled.div`
  	margin-left: 0.2rem;
    margin-top: 0.06rem;
    width: 0.5rem;
    height: 0.5rem;
    background: url(${require('../../static/img/layout-menu/gift.png')}) no-repeat;
    background-size: contain;
    cursor: pointer;
`;


// WEBPACK FOOTER //
// ./src/components/index/user-cell.js